import { render, staticRenderFns } from "./TournamentMessageBoard.vue?vue&type=template&id=883c8282&scoped=true"
import script from "./TournamentMessageBoard.vue?vue&type=script&lang=js"
export * from "./TournamentMessageBoard.vue?vue&type=script&lang=js"
import style0 from "./TournamentMessageBoard.vue?vue&type=style&index=0&id=883c8282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883c8282",
  null
  
)

export default component.exports